import React, { FC } from 'react'

import {
	PAGE_CLINIC_DASHBOARD,
	PAGE_COACHES,
	PAGE_USERS,
} from '@app/constants/navigation'
import { AppIcon } from '@app/components/AppIcon'
import SidebarNavLink from '@app/pages/Dashboard/SideBar/components/SidebarNavLink'
import SidebarNavAccordeon from '@app/pages/Dashboard/SideBar/components/SidebarNavAccordeon/SidebarNavAccordeon'

interface SlideMenuNavClinicManageTabsProps {
	readonly minimize?: boolean
	readonly locationPathName: string
}

const SlideMenuNavClinicManageTabs: FC<SlideMenuNavClinicManageTabsProps> = ({
	minimize,
	locationPathName,
}: SlideMenuNavClinicManageTabsProps) => {
	return (
		<>
			<SidebarNavAccordeon
				openLabel={'Clinic management'}
				minimize={minimize}
				openIconSlot={
					<AppIcon
						type={'patientAdd'}
						style={{ marginRight: '0.8rem' }}
					/>
				}
				sx={{ mb: 2.75, pr: 4 }}
				checked={
					locationPathName?.includes(PAGE_USERS) ||
					locationPathName?.includes(PAGE_COACHES)
				}
				menuData={
					<>
						<SidebarNavLink
							to={PAGE_USERS}
							label={'Users'}
							sx={{ mb: 3.5 }}
							checked={locationPathName?.includes(PAGE_USERS)}
						/>

						<SidebarNavLink
							to={PAGE_COACHES}
							label={'Coaches'}
							sx={{ mb: 3.5 }}
							checked={locationPathName === PAGE_COACHES}
						/>
					</>
				}
			/>

			<SidebarNavLink
				startIconSlot={
					<AppIcon
						type={'cabinet'}
						style={{ marginRight: '0.8rem' }}
					/>
				}
				to={PAGE_CLINIC_DASHBOARD}
				label={'Clinic Dashboard'}
				checked={locationPathName === PAGE_CLINIC_DASHBOARD}
				sx={{ mb: 3 }}
			/>
		</>
	)
}

export default SlideMenuNavClinicManageTabs
